import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, QueryList, SimpleChanges, ViewChildren } from '@angular/core';
import {DecimalPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  FormsModule,
  NgControl,
  ReactiveFormsModule,
  Validators
} from "@angular/forms";
import {DocumentsService} from "../../../../../../services/document.service";
import {UtilsService} from "../../../../../../services/utils.service";
import Swal from "sweetalert2";
import {environment} from "../../../../../../../environments/environment";
import {categoriasPlatillos} from "../../../../../../models/platillo.model";

@Component({
  selector: 'app-macros-dia',
  standalone: true,
  imports: [
    DecimalPipe,
    NgForOf,
    NgIf,
    ReactiveFormsModule,
    FormsModule,
    NgClass
  ],
  templateUrl: './macros-dia.component.html',
  styleUrl: './macros-dia.component.css'
})
export class MacrosDiaComponent implements OnInit, OnChanges{

  @Input({required: true}) userInfo: any;
  @Input({required: true}) detallePrograma: any;
  @Input({required: true}) detalleCliente: any;

  @Output() programaActualizado = new EventEmitter<void>(); // Emitirá un evento cuando se actualice
  @ViewChildren("checkboxes") checkboxes: QueryList<ElementRef>;

  macrosManual: boolean = true;
  FormMacrosManual: FormGroup;
  FormMacrosFormula: FormGroup;
  formDiasMacros: FormGroup;
  programaActivo: any
  checkAll: boolean = true

  intMetabolismoBasal: any;
  intTDEE: any;
  intObjetivoCalorias: any;
  intCarbohidratos: any;
  intPctCarbohidratos: any;
  intProteinas: any;
  intPctProteinas: any;
  intGrasas: any;
  intPctGrasas: any;
  programaFiltradoId: any;

  ageArray = this.utilService.age();
  mostrarAlerta: any = true

  constructor(private documentService: DocumentsService, private fb: FormBuilder, private utilService: UtilsService){
    this.FormMacrosManual = this.fb.group({
      caloriasManual: [0, [Validators.required]],
      carbsGramos: [0, [Validators.required]],
      carbsPorcentaje: [0, [Validators.required]],
      proteGramos: [0, [Validators.required]],
      protePorcentaje: [0, [Validators.required]],
      grasaGramos: [0, [Validators.required]],
      grasaPorcentaje: [0, [Validators.required]],
    });

    this.FormMacrosFormula = this.fb.group({
      sexoFormula: ['0', [Validators.required]],
      edadFormula: ['0', [Validators.required]],
      alturaFormula: [0, [Validators.required]],
      pesoFormula: [0, [Validators.required]],
      actividadFormula: ['sedentario', [Validators.required]],
      objetivoFormula: ['deficit', [Validators.required]],
      deficitCantidadFormula: [0, [Validators.required]],
      superavitCantidadFormula: [0, [Validators.required]],
      grsProteinaPesoFormula: [0, [Validators.required]],
      porcentajeGrasaFormula: [0, [Validators.required]],
    });

    this.formDiasMacros = this.fb.group({
      // CHECKBOX WITH AN ARRAY OF CHECKBOXES THAT AT LEAST ONE MUST BE CHECKED
      macrosDias: this.fb.array([], [Validators.required])
    })

  }

  ngOnInit(): void {
    //this.getGuias();
    this.checkAll = true
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log("=========================== onChanges Expediente Desde macros x dia=======================================")
    console.log('expediente cliente: ', this.detalleCliente)
    console.log('detalle progra: ', this.detallePrograma)
    if(typeof this.detalleCliente == 'undefined'){
      this.mostrarAlerta = true
    }else {
      this.mostrarAlerta = false
      if (changes.detallePrograma) {
        //agregar logica para saber cual es el programa activo, ahora se deja hardcode el primero del array
        let index = this.detalleCliente.expediente.programas.findIndex((item) => item.configuracionPrograma.id === this.detallePrograma?.documentId);
        this.programaActivo = this.detalleCliente.expediente.programas[index] //this.obtieneProgramaActual(this.detalleCliente)
        this.programaFiltradoId = this.programaActivo.configuracionPrograma.id
        this.setProgramaFiltrado(this.programaFiltradoId)
      }
    }
  }

  obtieneProgramaActual(cliente){
    let programaActivo = null;
    const hoy = new Date();
    cliente.expediente?.programas.forEach((programa: any) => {
      const fechaInicio = new Date(programa.periodos[0].fechaInicioDate);
      const fechaFin = new Date(programa.periodos[programa.periodos.length - 1].fechaFinDate);
      if (hoy >= fechaInicio && hoy <= fechaFin) {
        programaActivo = programa;
      }
    });

    if(programaActivo == null){
      programaActivo = cliente.expediente.programas[cliente.expediente.programas.length - 1]
    }

    return programaActivo;

  }

  setProgramaFiltrado(programaId: any){
    //this.platillosFiltrados = this.editarGuia.detalle.filter((platillo: any) => platillo.categoria === this.filtrarGuiaPorCatePlatillo);
    let programa = this.detalleCliente.expediente.programas.filter((programa: any) => programa.configuracionPrograma.id === programaId);
    programa = programa[0];

    for(let i in programa.configuracionMacrosXdia){
      let fecha: any;
      fecha = programa.configuracionMacrosXdia[i].fecha;
      fecha = fecha.split("-");
      let newDate = new Date( fecha[2], fecha[1] - 1, fecha[0]);
      programa.configuracionMacrosXdia[i].timestamp = newDate.getTime() + 86399000;
      programa.configuracionMacrosXdia[i].timestampActual = Date.now();
      console.log(newDate.getTime());
    }

    console.log('macros x dia:', programa.configuracionMacrosXdia)
    this.programaActivo = programa
    this.programaFiltradoId = this.programaActivo.configuracionPrograma.id

  }

  onChangeCalorias(event){
    /*** ***/
    let calorias = this.FormMacrosManual.value.caloriasManual
    let gramosProteina = this.FormMacrosManual.value.proteGramos
    let pctGrasa = this.FormMacrosManual.value.grasaPorcentaje

    let pctProteina: number = 0;
    if(this.FormMacrosManual.value.caloriasManual>0){
      pctProteina = ((this.FormMacrosManual.value.proteGramos*4)/calorias)*100;
    }else{
      pctProteina = 0;
    }

    this.FormMacrosManual.patchValue({protePorcentaje: pctProteina.toFixed(0)})

    let gramosGrasa = ((pctGrasa/100)*calorias)/9;
    this.FormMacrosManual.patchValue({grasaGramos: gramosGrasa.toFixed(0)})
    let pctCarbs: number
    if(calorias>0){
      pctCarbs = 100 - pctProteina - pctGrasa;
    }else{
      pctCarbs = 0;
    }

    this.FormMacrosManual.patchValue({carbsPorcentaje: pctCarbs.toFixed(0)})

    let gramosCarbs = ((pctCarbs/100)*calorias)/4;
    this.FormMacrosManual.patchValue({carbsGramos: gramosCarbs.toFixed(0)})
  }

  asignaMacros(){
    const formArray = this.formDiasMacros.get('macrosDias') as FormArray;

    if(formArray.value.length < 1){
      Swal.fire("Alerta", "Debe seleccionar al menos un día para asignar los macros.", "warning")
      return
    }

    Swal.fire({
      title: 'Modificar Macros',
      html: '¿Seguro que desea modificar los macros en base a la fórmula para los días seleccionados?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.isConfirmed) {
        let arrDiasAsignar: any = []
        let arrMacrosDia: any = []

        arrDiasAsignar = formArray.value
        arrMacrosDia = this.programaActivo.configuracionMacrosXdia

        for(let i in arrMacrosDia){
          for(let j in arrDiasAsignar){
            if(arrMacrosDia[i].dia == arrDiasAsignar[j]){
              arrMacrosDia[i].calorias = this.FormMacrosManual.value.caloriasManual;
              arrMacrosDia[i].carbsGramos = this.FormMacrosManual.value.carbsGramos;
              arrMacrosDia[i].carbsPorcentaje = this.FormMacrosManual.value.carbsPorcentaje;
              arrMacrosDia[i].proteGramos = this.FormMacrosManual.value.proteGramos;
              arrMacrosDia[i].protePorcentaje = this.FormMacrosManual.value.protePorcentaje;
              arrMacrosDia[i].grasaGramos = this.FormMacrosManual.value.grasaGramos;
              arrMacrosDia[i].grasaPorcentaje = this.FormMacrosManual.value.grasaPorcentaje;
            }
          }
        }

        this.programaActivo.configuracionMacrosXdia = arrMacrosDia

        for(let k in this.detalleCliente.expediente.programas){
          if(this.detalleCliente.expediente.programas[k].configuracionPrograma.id == this.programaActivo.configuracionPrograma.id){
            this.detalleCliente.expediente.programas[k] = this.programaActivo
          }
        }

        let clienteDocumentModel = {
          expediente: {
            programas: this.detalleCliente.expediente.programas
          }
        }
        //Actualizar el expediente del cliente
        this.documentService.updateDocumentInContainer(
            environment.businessId,
            this.userInfo.documentContainerId,
            this.detalleCliente.documentId,
            'cliente',
            null,
            clienteDocumentModel
        ).subscribe({
          next: (data: any) => {
            //mensaje exito
            this.checkAllFn(false)
          },
          error: (error) => {
            console.log(error);
          },
          complete: () => {
            //this.inicializarFormularios();
            Swal.fire({
              title: "Asignación exitosa",
              text: "Se han asignado las macros de manera exitosa en los días seleccionados.",
              icon: "success",
            })
          }
        })
      }
    })
  }

  inicializarFormularios(){
    this.checkAll = true

    this.intMetabolismoBasal = 0;
    this.intTDEE = 0;

    this.intObjetivoCalorias = 0;
    this.intCarbohidratos = 0;
    this.intPctCarbohidratos = 0;
    this.intProteinas = 0;
    this.intPctProteinas = 0;
    this.intGrasas = 0;
    this.intPctGrasas = 0;

    this.FormMacrosManual.setValue({
      caloriasManual: 0,
      carbsGramos: 0,
      carbsPorcentaje: 0,
      proteGramos: 0,
      protePorcentaje: 0,
      grasaGramos: 0,
      grasaPorcentaje: 0,
    })

    this.FormMacrosFormula.setValue({
      sexoFormula: '0',
      edadFormula: '0',
      alturaFormula: 0,
      pesoFormula: 0,
      deficitCantidadFormula: 0,
      superavitCantidadFormula: 0,
      grsProteinaPesoFormula: 0,
      porcentajeGrasaFormula: 0,
      actividadFormula: 'sedentario',
      objetivoFormula: 'deficit',
    })

    // desmarcar todos los checks
    this.checkboxes.forEach((element) => {
      element.nativeElement.checked = false;
      for(let j in this.programaActivo.configuracionMacrosXdia){
        const formArray = this.formDiasMacros.get('macrosDias') as FormArray;
        const index = formArray.controls.findIndex(ctrl => ctrl.value == this.programaActivo.configuracionMacrosXdia[j].dia);
        if (index !== -1) {
          formArray.removeAt(index);
        }
      }
    });
  }

  checkAllFn(check){
    if(check){
      this.checkAll = false
      // marcar todos los checks
      this.checkboxes.forEach((element) => {
        element.nativeElement.checked = true;
        const formArray = this.formDiasMacros.get('macrosDias') as FormArray;
        for(let i in this.programaActivo.configuracionMacrosXdia){
          if(this.programaActivo.configuracionMacrosXdia[i].timestamp > this.programaActivo.configuracionMacrosXdia[i].timestampActual){
            formArray.push(this.fb.control(this.programaActivo.configuracionMacrosXdia[i].dia));
          }
        }
      });
    }else{
      this.checkAll = true
      // desmarcar todos los checks
      this.checkboxes.forEach((element) => {
        element.nativeElement.checked = false;
        for(let j in this.programaActivo.configuracionMacrosXdia){
          if(this.programaActivo.configuracionMacrosXdia[j].timestamp > this.programaActivo.configuracionMacrosXdia[j].timestampActual){
            const formArray = this.formDiasMacros.get('macrosDias') as FormArray;
            const index = formArray.controls.findIndex(ctrl => ctrl.value == this.programaActivo.configuracionMacrosXdia[j].dia);
            if (index !== -1) {
              formArray.removeAt(index);
            }
          }
        }
      });
    }


  }

  onCheckboxChange(event: any, controlName: string) {
    const checkbox = event.target as HTMLInputElement;
    const formArray = this.formDiasMacros.get(controlName) as FormArray;

    if (checkbox.checked) {
      // Agregar si no está presente
      formArray.push(this.fb.control(checkbox.value));
    } else {
      // Remover si está presente
      const index = formArray.controls.findIndex(ctrl => ctrl.value === checkbox.value);
      if (index !== -1) {
        formArray.removeAt(index);
      }
    }
  }

  asignaMacrosFormula(){
    const formArray = this.formDiasMacros.get('macrosDias') as FormArray;

    if(formArray.value.length < 1){
      Swal.fire("Alerta", "Debe seleccionar al menos un día para asignar los macros.", "warning")
      return
    }

    Swal.fire({
      title: 'Modificar Macros',
      html: '¿Seguro que desea modificar los macros en base a la fórmula para los días seleccionados?',
      icon: 'warning',
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Aceptar'
    }).then((result) => {
      if (result.isConfirmed) {
        let arrDiasAsignar: any = []
        let arrMacrosDia: any = []

        arrDiasAsignar = formArray.value
        arrMacrosDia = this.programaActivo.configuracionMacrosXdia

        for(let i in arrMacrosDia){
          for(let j in arrDiasAsignar){
            if(arrMacrosDia[i].dia == arrDiasAsignar[j]){
              arrMacrosDia[i].calorias = this.intObjetivoCalorias;
              arrMacrosDia[i].carbsGramos = this.intCarbohidratos;
              arrMacrosDia[i].carbsPorcentaje = this.intPctCarbohidratos;
              arrMacrosDia[i].proteGramos = this.intProteinas;
              arrMacrosDia[i].protePorcentaje = this.intPctProteinas;
              arrMacrosDia[i].grasaGramos = this.intGrasas;
              arrMacrosDia[i].grasaPorcentaje = this.intPctGrasas;
            }
          }
        }

        this.programaActivo.configuracionMacrosXdia = arrMacrosDia

        for(let k in this.detalleCliente.expediente.programas){
          if(this.detalleCliente.expediente.programas[k].configuracionPrograma.id == this.programaActivo.configuracionPrograma.id){
            this.detalleCliente.expediente.programas[k] = this.programaActivo
          }
        }

        let clienteDocumentModel = {
          expediente: {
            programas: this.detalleCliente.expediente.programas
          }
        }
        // Actualizar el expediente del cliente
        this.documentService.updateDocumentInContainer(
            environment.businessId,
            this.userInfo.documentContainerId,
            this.detalleCliente.documentId,
            'cliente',
            null,
            clienteDocumentModel
        ).subscribe({
          next: (data: any) => {
            //mensaje exito
            this.checkAllFn(false)
          },
          error: (error) => {
            console.log(error);
          },
          complete: () => {
            //this.inicializarFormularios();
            Swal.fire({
              title: "Asignación exitosa",
              text: "Se han asignado las macros de manera exitosa en los días seleccionados.",
              icon: "success",
            })
          }
        })
      }
    })
  }

  calculaMacrosFormulaFn(event){

    let strSexo = this.FormMacrosFormula.value.sexoFormula;
    let intEdad = this.FormMacrosFormula.value.edadFormula;
    let intAltura = this.FormMacrosFormula.value.alturaFormula;
    let intPeso = this.FormMacrosFormula.value.pesoFormula;

    let intBMR: number = 0;

    if(strSexo!="" && intEdad!="" && intAltura!=0 && intAltura!=null && intPeso!=0 && intPeso!=null){

      // Fórmula de Mifflin-St. Jeor

      if(strSexo=="m"){
        intBMR = 10*parseFloat(intPeso) + 6.25*parseFloat(intAltura) - 5*parseFloat(intEdad) + 5;
      }else if(strSexo=="f"){
        intBMR = 10*parseFloat(intPeso) + 6.25*parseFloat(intAltura) - 5*parseFloat(intEdad) - 161;
      }

    }

    this.intMetabolismoBasal = intBMR.toFixed(0);

    /////////////////////////////////////

    let radioSedentario = this.FormMacrosFormula.value.actividadFormula

    let intTDEE = 0;

    if(intBMR>=0){
      let intNivelActividad = 0
      switch (radioSedentario){
        case 'sedentario': {
          intNivelActividad = 1.2;
          break;
        }
        case 'ligeroActivo': {
          intNivelActividad = 1.375;
          break;
        }
        case 'activo': {
          intNivelActividad = 1.55;
          break;
        }
        case 'muyActivo': {
          intNivelActividad = 1.725;
          break;
        }
      }

      intTDEE = intBMR*intNivelActividad;

    }

    this.intTDEE = intTDEE.toFixed(0);

    //   /////////////////////////////////////
    let radioObjetivo = this.FormMacrosFormula.value.objetivoFormula

    let intGraPro = this.FormMacrosFormula.value.grsProteinaPesoFormula //$( "#"+ strDiv ).find( "#intGraPro" ).val();
    let intPctGrasas = this.FormMacrosFormula.value.porcentajeGrasaFormula //$( "#"+ strDiv ).find( "#intPctGrasa" ).val();

    let intProteinas = intGraPro*parseFloat(intPeso);

    let intObjetivoCalorias = 0;
    let intDeficit = 0
    let intSuperavit = 0

    if(intTDEE>=0){

      if(radioObjetivo == 'deficit'){

        intDeficit = this.FormMacrosFormula.value.deficitCantidadFormula //$( "#"+ strDiv ).find( "#intDeficit" ).val();
        intObjetivoCalorias = intTDEE - intDeficit;

      }else if(radioObjetivo == 'mtto'){

        intObjetivoCalorias = intTDEE;

      }else if(radioObjetivo == 'superavit'){

        intSuperavit = this.FormMacrosFormula.value.superavitCantidadFormula //$( "#"+ strDiv ).find( "#intSuperavit" ).val();
        intObjetivoCalorias = intTDEE + intSuperavit;

      }

      intObjetivoCalorias = Math.round(intObjetivoCalorias);

      let intPctProteinas = ((intProteinas*4)/intObjetivoCalorias)*100;
      //intPctProteinas = Math.round(intPctProteinas,0);

      let intGrasas = ((intPctGrasas/100)*intObjetivoCalorias)/9;
      //intGrasas = Math.round(intGrasas,0);

      let intPctCarbohidratos = 100 - intPctProteinas - intPctGrasas;
      //intPctCarbohidratos = Math.round(intPctCarbohidratos,0);

      let intCarbohidratos = ((intPctCarbohidratos/100)*intObjetivoCalorias)/4;
      //intCarbohidratos = Math.round(intCarbohidratos,0);

      this.intObjetivoCalorias = intObjetivoCalorias
      this.intCarbohidratos = intCarbohidratos.toFixed(0);
      this.intPctCarbohidratos = intPctCarbohidratos.toFixed(0);
      this.intProteinas = intProteinas
      this.intPctProteinas = intPctProteinas.toFixed(0);
      this.intGrasas = intGrasas.toFixed(0);
      this.intPctGrasas = intPctGrasas.toFixed(0);

    }else{

      this.intObjetivoCalorias = 0;
      this.intCarbohidratos = 0;
      this.intPctCarbohidratos = 0;
      this.intProteinas = 0;
      this.intPctProteinas = 0;
      this.intGrasas = 0;
      this.intPctGrasas = 0;

    }
  }

  protected readonly categoriasPlatillos = categoriasPlatillos;

}
